import React from 'react'
import './screen.scss'
export default function Screen({input}) {
    return (
        <div className="screen">
          { input}
        </div>
    )
}
